import * as LocalOperations from "@/Common/Operations/operations.local";
import { LocalEvent } from "@/Common/Stores/Actions/LocalEvent";
import { BaseOperationHandler } from "@/Common/Stores/Handlers/Local/BaseOperationHandler";
import { PopulationBasedFundingPortfolioModel } from "@/Portfolio/Models/PopulationBasedFunding/PopulationBasedFundingPortfolioModel";

class PopulationBasedFundingHandler extends BaseOperationHandler {
    constructor() {
        super();
        this.RegisterOperation(LocalOperations.Portfolio.PopulationBasedFunding_LoadEvents, this.PopulationBasedFundingLoadEvents);
    }

    private PopulationBasedFundingLoadEvents(request: LocalEvent): void {
        const stateChanges = request.Get<Partial<PopulationBasedFundingPortfolioModel>>("stateChanges");
        portfolioStore.populationBasedFundingPortfolioModel = { ...portfolioStore.populationBasedFundingPortfolioModel, ...stateChanges };
    }
}

export { PopulationBasedFundingHandler };
